import React, { useEffect, useRef } from "react";
import "./PopupNotice.css";

const PopupNotice = ({ popup, visible, onClose, onClick }) => {
  const dialogRef = useRef(null);
  const closeRef = useRef(null);

  useEffect(() => {
    if (!visible) return undefined;
    const previousActive = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const focusDialog = () => {
      closeRef.current?.focus?.({ preventScroll: true });
      if (document.activeElement !== closeRef.current) dialogRef.current?.focus?.({ preventScroll: true });
    };
    focusDialog();

    const handleKey = (event) => {
      if (event.key === "Escape") onClose?.();
      if (event.key !== "Tab" || !dialogRef.current) return;
      const focusable = [...dialogRef.current.querySelectorAll(
        "button:not([disabled]), a[href], [tabindex]:not([tabindex=\"-1\"]):not([disabled])"
      )];
      if (focusable.length === 0) {
        event.preventDefault();
        dialogRef.current.focus();
        return;
      }
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || !dialogRef.current.contains(document.activeElement))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || !dialogRef.current.contains(document.activeElement))) {
        event.preventDefault();
        first.focus();
      }
    };
    window.addEventListener("keydown", handleKey);
    return () => {
      window.removeEventListener("keydown", handleKey);
      document.body.style.overflow = previousOverflow;
      if (previousActive && typeof previousActive.focus === "function" && document.contains(previousActive)) {
        previousActive.focus({ preventScroll: true });
      }
    };
  }, [visible, onClose]);

  if (!visible || !popup) return null;

  return (
    <div className="notice-popup-backdrop" role="presentation" onMouseDown={(event) => {
      if (event.target === event.currentTarget) onClose?.();
    }}>
      <section
        className={`notice-popup notice-popup--${popup.type}`}
        role="dialog"
        aria-modal="true"
        aria-label={popup.title ? undefined : "اطلاعیه"}
        aria-labelledby={popup.title ? "notice-popup-title" : undefined}
        aria-describedby={popup.body ? "notice-popup-body" : undefined}
        ref={dialogRef}
        tabIndex={-1}
      >
        <button ref={closeRef} className="notice-popup__close" type="button" onClick={onClose} aria-label="بستن اطلاعیه">×</button>
        {popup.imageUrl && <img className="notice-popup__image" src={popup.imageUrl} alt={popup.title ? `تصویر ${popup.title}` : "تصویر اطلاعیه"} />}
        {popup.title && <h2 id="notice-popup-title" className="notice-popup__title">{popup.title}</h2>}
        {popup.body && <p id="notice-popup-body" className="notice-popup__body">{popup.body}</p>}
        {popup.ctaLabel && popup.ctaUrl && (
          <a className="notice-popup__cta" href={popup.ctaUrl} target="_blank" rel="noopener noreferrer" onClick={onClick}>
            {popup.ctaLabel}
          </a>
        )}
      </section>
    </div>
  );
};

export default PopupNotice;
